import { Component, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InvoiceItemQuantityComparison } from '../types/InvoiceOrderComparison';

/**
 * The "difference" cell of the billing row (UC_2026): a partial invoice and a fully invoiced position
 * are neutral hints, only over-invoicing is a deviation. A partial invoice is the normal case on an
 * invoice, so it must never look like a warning — hence blue for partial, green for complete and red
 * only when more was invoiced than ordered.
 *
 * <p>The bar carries the same statement as the text and exists because a share is read faster than
 * two numbers; it is therefore marked decorative and never the only carrier of the information.
 */
@Component({
    selector: 'invoice-item-quantity-status',
    imports: [CommonModule, TranslateModule],
    templateUrl: './invoice-item-quantity-status.component.html',
    styleUrl: './invoice-item-quantity-status.component.scss',
})
export class InvoiceItemQuantityStatusComponent {
    public readonly quantity: InputSignal<InvoiceItemQuantityComparison> = input.required<InvoiceItemQuantityComparison>();

    /** Already translated unit name of the position. */
    public readonly unit: InputSignal<string> = input<string>('');
}
